module.exports = __webpack_public_path__ + "img/maximize.554663cb.svg";